export default __webpack_public_path__ + "a54b7457c9448fc575c32b368f4b0fec.svg";